var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarning = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8629 15.3082L10.313 0.766826C9.76593 -0.255609 8.34349 -0.255609 7.7964 0.766826L0.137093 15.3082C-0.300581 16.217 0.355931 17.2394 1.45012 17.2394H16.5499C17.6441 17.2394 18.3006 16.217 17.8629 15.3082ZM7.90581 4.97018H10.0942V11.5592H7.90581V4.97018ZM7.79639 14.7402H10.2036V12.5817H7.79639V14.7402Z",
    fill: "#E4A511"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warning.16f953ce5d6e4195e17bd74a5bf358bf.svg";